import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../../../services';

@Component({
  selector: 'cmg-clear2-ui-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  private readonly _authService = inject(AuthService);

  ngOnInit() {
    this._authService.logout();
  }
}
